import { createVfm } from 'vue-final-modal'

export default defineNuxtPlugin({
  name: 'vue-final-modal',
  parallel: true,
  setup: (nuxtApp) => {
    nuxtApp.vueApp.use(createVfm())
  },
})
